import { useEffect, useState } from "react";
import Navbar from "./Navbar";
import { db } from "../Firebase";
import Footer from "./Footer";
import { useNavigate } from "react-router-dom";
import { FaWhatsapp } from "react-icons/fa";

export default function Programs() {

    const navi = useNavigate();
    const [pro, setpro] = useState([]);

    function fetchprograms() {
        db.collection("programs").onSnapshot((succ) => {
            setpro(succ.docs);
        })
    }

    useEffect(() => {
        fetchprograms()
    }, [])

    return (
        <>
            <title>Fitness Programs | The Fitness Expert | Fat Loss & Muscle Gain</title>
            <meta name="description" content="Explore personalized fitness programs from The Fitness Expert, including Fat Loss, Muscle Building, Body Recomposition, Nutrition Coaching, and Online Personal Training. Choose the perfect program to achieve your fitness goals." />
            <meta name="keywords" content="fitness programs, online fitness coaching, fat loss program, muscle building program, body recomposition, nutrition coaching, online personal trainer, personalized workout plan, weight loss program, strength training, fitness transformation, fitness expert, online gym coach, workout plans India" />
            <meta property="og:title" content="Fitness Programs | The Fitness Expert" />
            <meta property="og:site_name" content="The Fitness Expert" />
            <meta property="og:url" content="https://thefitnessexpert.in/user/Programs" />
            <meta property="og:description" content="Choose from expert-designed fitness programs including Fat Loss, Muscle Building, Body Recomposition, Nutrition Coaching, and Online Personal Training. Start your transformation today." />
            <meta property="og:image" content="logo.png"></meta>
            <meta name="twitter:card" content="app" />
            <meta name="twitter:site" content="@thefitnessexpert" />
            <meta name="twitter:description" content="Choose from expert-designed fitness programs including Fat Loss, Muscle Building, Body Recomposition, Nutrition Coaching, and Online Personal Training. Start your transformation today." />
            <meta name="twitter:app:country" content="India" />
            <Navbar />
            <section className="py-5 bg-light">
                <div className="container">
                    <div className="text-center mb-5">
                        <span className="badge bg-danger-subtle text-danger px-3 py-2 mb-3">
                            Classes
                        </span>
                        <h1 className="fw-bold display-6 text-uppercase">
                            Training Programs
                        </h1>
                        <p className="text-muted mx-auto widthpro">
                            Whether you're a beginner or a seasoned athlete our fitness
                            membership provides you with access to state-of-the-art
                            equipment, as well as expert coaching and support.
                        </p>
                    </div>
                    <div className="position-fixed bottom-0 end-0 p-3 z-3">
                        <button className="fixed-join-btn text-light fw-bold px-3 py-2 shadow rounded-pill bgcolor"
                            onClick={() =>
                                window.open("https://wa.me/919876857579?text=Hello%20Harman%20Sir%20👋%0A%0AI%20visited%20your%20website%20and%20I'm%20interested%20in%20your%20fitness%20coaching%20programs.", "_blank"
                                )}>
                            <FaWhatsapp size={24} />
                        </button>
                    </div >
                    <div className="row g-4">
                        {pro.map((row, index) => (
                            <div onClick={() => navi("/user/ProgramDetails?id=" + row.id)} className="col-lg-4 col-md-6" key={index}>
                                <div className="program-card">
                                    <img src={row.data().img} alt={row.data().name} className="img-fluid w-100" />
                                    <div className="program-overlay">
                                        <div>
                                            <h4 className="text-white fw-semibold mb-3">{row.data().name}</h4>
                                            <button onClick={() => navi("/user/ProgramDetails?id=" + row.id)} className="btn btn-light rounded-pill px-4">
                                                Class Details →
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
            <Footer />
        </>
    )
}